import React from "react";
import styled from "styled-components";

import OrderHistoryHeader from "./OrderHistoryHeader";
import OrderHistoryFooter from "./OrderHistoryFooter";
import { CartFooter } from "@arcteryx/components-cart";

const Wrap = styled.div`
  position: relative;
  height: inherit;
  width: 100%;
  overflow: hidden;
`;
const ItemWrap = styled.div``;
const OrderHistoryShell = ({ order, children, returnUrl, isOrderHistory }) => (
  <Wrap>
    <OrderHistoryHeader order={order} />
    <ItemWrap>{children}</ItemWrap>
    {isOrderHistory ? (
      <CartFooter cart={order} showTax={true} isBoldTotal={true} returnUrl={returnUrl} />
    ) : (
      <OrderHistoryFooter order={order} returnUrl={returnUrl} />
    )}
  </Wrap>
);

export default OrderHistoryShell;
